// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iAFcdXnYf4Uwkn {
  display: inline-block;
  margin-top: 14px;
  padding: var(--ds-space-150, 12px) 14px;
  border: 1px solid var(--ds-border-discovery, #8777d9);
  border-radius: 4px;
  background-color: var(--ds-surface, #ffffff);
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  text-decoration: none;
}
.iAFcdXnYf4Uwkn:hover {
  background-color: var(--ds-background-discovery-hovered, #eae6ff);
  color: var(--ds-text, #172b4d);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonLink": `iAFcdXnYf4Uwkn`
};
export default ___CSS_LOADER_EXPORT___;
